export default __webpack_public_path__ + "static/home-banner-bottom-3e43bf5a3fe22fe11c9e2fc35961b19f.png";